import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { operationBCIService } from '../../../services/entityService';
import { OperationBCI } from '../types';

// Chargement de l'operation acheteur. Expose un refetch explicite pour rafraichir
// l'etat React apres une action, au lieu du window.location.reload() de l'ancienne infra.
export const useOperationData = () => {
  const { id } = useParams<{ id: string }>();
  const [operation, setOperation] = useState<OperationBCI | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOperation = useCallback(async () => {
    if (!id) return;
    setLoading(true);
    setError(null);
    try {
      const data = await operationBCIService.getById(id);
      setOperation(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors du chargement');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchOperation();
  }, [fetchOperation]);

  return { operation, setOperation, loading, error, refetch: fetchOperation };
};
